import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
// ✅ CORRECCIÓN: La importación ahora apunta a 'firebase/firestore'
import { collection, onSnapshot, query, doc, updateDoc, addDoc, deleteDoc, writeBatch, serverTimestamp } from 'firebase/firestore';
import toast from 'react-hot-toast';
import { FaPlus, FaTrash, FaPaperPlane } from 'react-icons/fa';

function RequerimientoSoftplay() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [newItemName, setNewItemName] = useState("");

    const requerimientoCollectionRef = collection(db, "requerimientoSoftplay");

    useEffect(() => {
        const q = query(requerimientoCollectionRef);
        const unsubscribe = onSnapshot(q, (snapshot) => {
            const itemsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setItems(itemsData);
            setLoading(false);
        });
        return () => unsubscribe();
    }, []);

    const handleAddItem = async () => {
        if (!newItemName.trim()) return toast.error("El nombre del material no puede estar vacío.");
        await addDoc(requerimientoCollectionRef, { nombre: newItemName, estado: 'Pendiente', cantidad: 1 });
        setNewItemName("");
        toast.success("¡Material añadido al requerimiento!");
    };

    const handleDeleteItem = async (id) => {
        if (window.confirm("¿Seguro que quieres eliminar este material del requerimiento?")) {
            await deleteDoc(doc(db, 'requerimientoSoftplay', id));
            toast.success("Material eliminado del requerimiento.");
        }
    };

    const handleUpdate = async (id, field, value) => {
        const docRef = doc(db, 'requerimientoSoftplay', id);
        await updateDoc(docRef, { [field]: value });
    };
    
    const handleConsolidateRequirements = async () => {
        const itemsToConsolidate = items.filter(item => item.estado === 'Pendiente' && item.cantidad > 0);
        if (itemsToConsolidate.length === 0) {
            return toast.error("No hay materiales pendientes para enviar a compras.");
        }

        const toastId = toast.loading('Enviando requerimiento a compras...');
        try {
            const batch = writeBatch(db);
            const newConsolidatedRef = doc(collection(db, "requerimientosConsolidados"));
            batch.set(newConsolidatedRef, {
                fechaCreacion: serverTimestamp(),
                departamento: "Softplay",
                estado: "Pendiente de Compra",
                items: itemsToConsolidate.map(({ nombre, cantidad }) => ({ nombre, cantidad })),
            });

            itemsToConsolidate.forEach(item => {
                const docRef = doc(db, 'requerimientoSoftplay', item.id);
                batch.delete(docRef);
            });
            
            await batch.commit();
            toast.success("Requerimiento enviado al área de compras.", { id: toastId });
        } catch(error) {
            console.error("Error al consolidar requerimiento: ", error);
            toast.error("No se pudo enviar el requerimiento.", { id: toastId });
        }
    };
    
    const inputStyle = "w-full px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[#18BC9C] focus:border-[#18BC9C]";

    return (
        <div className="bg-white rounded-lg shadow-md flex-grow flex flex-col">
            <div className="p-6 border-b flex flex-col md:flex-row items-center gap-4">
                <input 
                    type="text" 
                    value={newItemName} 
                    onChange={(e) => setNewItemName(e.target.value)} 
                    placeholder="Nuevo material (ej: Polipiel azul)" 
                    className={`${inputStyle} flex-grow h-11`}
                />
                <button onClick={handleAddItem} className="w-full md:w-auto bg-[#2C3E50] text-white font-bold h-11 px-6 rounded-lg shadow-md hover:bg-gray-700 flex items-center justify-center shrink-0">
                    <FaPlus className="mr-2"/> Añadir Material
                </button>
            </div>
            <div className="flex-grow overflow-y-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th scope="col" className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Estado</th>
                            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Material</th>
                            <th scope="col" className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Cantidad</th>
                            <th scope="col" className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Acciones</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {loading ? (<tr><td colSpan="4" className="text-center py-8 text-gray-500">Cargando...</td></tr>) : 
                        items.map(item => (
                            <tr key={item.id} className="hover:bg-gray-50">
                                <td className="px-6 py-4 whitespace-nowrap w-40">
                                    <select value={item.estado} onChange={(e) => handleUpdate(item.id, 'estado', e.target.value)} className={`w-full p-2 rounded text-xs font-bold text-center border-none focus:ring-1 focus:ring-teal-500 ${item.estado === 'Listo' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`}>
                                        <option>Pendiente</option>
                                        <option>Listo</option>
                                    </select>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="text-sm font-medium text-gray-900">{item.nombre}</div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap w-32">
                                    <input type="number" value={item.cantidad || 1} onChange={(e) => handleUpdate(item.id, 'cantidad', Number(e.target.value))} className={`${inputStyle} text-center h-10`} min="1" />
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium w-32">
                                    <button onClick={() => handleDeleteItem(item.id)} className="text-gray-400 hover:text-red-600 p-2 transition-colors duration-200"><FaTrash /></button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                 {items.length === 0 && !loading && <p className="text-center text-gray-400 py-12">No hay materiales en la lista de requerimientos.</p>}
            </div>
            <div className="p-4 border-t mt-auto bg-gray-50">
                <button onClick={handleConsolidateRequirements} className="w-full bg-blue-600 text-white font-bold h-12 px-6 rounded-lg shadow-md hover:bg-blue-700 flex items-center justify-center transition-colors duration-200">
                    <FaPaperPlane className="mr-3"/> ENVIAR REQUERIMIENTO A COMPRAS
                </button>
            </div>
        </div>
    );
}

export default RequerimientoSoftplay;